import axios from 'axios'
import { Message } from 'element-ui'
import Notify from 'quasar/src/plugins/Notify.js';
import router from '../router'
import store from '../store'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 10000,
  withCredentials: false,
});

instance.interceptors.request.use(
  req => {
    if (req.url != "oauth/token" && store.getters.getToken) {
      req.headers.Authorization = "Bearer " + store.getters.getToken;
    }
    return req;
  }
);

instance.interceptors.response.use(
  res => {
    if (res.request.responseType == "blob" || res.data.errorCode == "00000" || res.config.url.indexOf('oauth') > -1) {
      return res;
    } else {
      Notify.create({
        type: "negative",
        message: res.data.errorMsg,
      });
      return Promise.reject(res.data.errorMsg);
    }
  },
  err => {
    console.log("login error");
    if (err.code == 'ECONNABORTED' && err.message.indexOf('timeout') != -1) {
      Message.error("请求超时，请稍候再试！");
    } else if (err.response.status == "400" && err.response.data.error_description == "Bad credentials") {
      Message.error("用户名或密码错误！");
    } else if (err.response.status == "401") {
      if (!err.response.data.error_description) {
        Message.error("凭证失效，请重新登录");
        router.push("/login")
      } else if (err.response.data.error_description.indexOf("Access token expired") != -1) {
        Message.error("凭证过期，请重新登录");
        router.push("/login")
      } else if (err.response.data.error_description.indexOf("Invalid access token") != -1) {
        Message.error("凭证失效，请重新登录");
        //store.commit('clearToken');
        router.push("/login")
      } else {
        Message.error("您未登录，请先登录！");
        router.push("/login")
      }
    } else if (err.response.status == "400") {
      Message.error("请求错误");
    } else if (err.response.status == "500") {
      Message.error("服务器异常，请联系管理员");
    }
    // return err;
    return Promise.reject(err);
  }
);

export default instance